import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  FolderDto,
  UpdateFolderDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_FOLDERS } from "../domain";
import { ACTION_GET_FOLDER } from "../GetFolder";

import { foldersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_FOLDER = "UPDATE_FOLDER";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type UpdateFormRequest = {
  folderId: string;
  dto: UpdateFolderDto;
};

const updateFolder = async (req: UpdateFormRequest): Promise<FolderDto> => {
  const response = await foldersApi.foldersControllerUpdateFolder(
    req.folderId,
    req.dto,
  );

  return response.data;
};

export const useUpdateFolder = (
  user: UserProfileDto | null,
): {
  updateFolder: UseMutateFunction<FolderDto, Error, UpdateFormRequest, unknown>;
  updateFolderEnabled: boolean;
  isSuccessUpdateFolder: boolean;
  isPendingUpdateFolder: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FOLDERS, ACTION_UPDATE_FOLDER],
    mutationFn: enabled ? updateFolder : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FOLDERS, ACTION_GET_FOLDER],
      });
    },
  });

  return {
    updateFolder: mutate,
    updateFolderEnabled: enabled,
    isSuccessUpdateFolder: isSuccess,
    isPendingUpdateFolder: isPending,
  };
};
